import sortedIndexBy from 'lodash/sortedIndexBy'
import { useCurrentFrame } from 'remotion'
import { Paragraph } from '../types'

export function useSpeaker(paragraphs: Paragraph[]) {
  const frame = useCurrentFrame()

  const index = Math.max(
    sortedIndexBy(
      paragraphs,
      { start: frame / 30, end: 0, speaker: {} },
      (p) => p.start,
    ) - 1,
    0,
  )

  return paragraphs.at(index)?.speaker
}
